import React from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";

const ConfirmationDialog = (props) => {
    const dialogContent = (
        <React.Fragment>
            {props.content.map((item, index) => {
                return (
                    <Box key={`confirmation-dialog-content-part-${index}`}
                         marginTop={index !== 0 ? 2 : 0}>
                        <Typography variant={"body2"}
                                    color={"textSecondary"}>
                            {item}
                        </Typography>
                    </Box>
                )
            })}
        </React.Fragment>
    );

    const dialogActions = (
        <React.Fragment>
            <Button autoFocus
                    onClick={props.handleDialogClose}
                    color="primary"
                    variant="contained">
                Chiudi
            </Button>
        </React.Fragment>
    );

    return (
        <GenericDialog dialogWidth="xs"
                       open={props.open}
                       handleDialogClose={props.handleDialogClose}
                       handleDialogCloseButton={props.handleDialogClose}
                       dialogActions={dialogActions}
                       dialogContent={dialogContent}>
            <Typography variant={"h6"}>
                {props.dialogTitle}
            </Typography>
        </GenericDialog>
    )
}

ConfirmationDialog.propTypes = {
    dialogTitle: PropTypes.string.isRequired,
    content: PropTypes.array.isRequired,
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired
}

export {ConfirmationDialog}
